<template>
  <el-row>
    <el-col :span="24">
      <div class="wrap">
        <div class="center">
          <div class="head_choose">
            <div class="choose_unit">
              <span>活动类型：</span>
              <div class="center_box">
                <span
                  v-for="(item, index) in acitiviKind"
                  :key="index"
                  :class="[
                    'center_box_child',
                    searchForm.Type == item.ID ? 'isActiv' : '',
                  ]"
                  @click="changeUnitA(item)"
                >{{ item.Title }}</span>
              </div>
            </div>
            <div class="choose_unit">
              <span>活动状态：</span>
              <div class="center_box">
                <span
                  :class="[
                    'center_box_child',
                    searchForm.Status == item.code ? 'isActiv' : '',
                  ]"
                  @click="changeTechA(item)"
                  v-for="(item, index) in acitiviState"
                  :key="index"
                >{{ item.name }}</span>
              </div>
            </div>
          </div>
          <div class="listContainer">
            <div v-for="(i, n) in DataList" :key="n" class="card_box_yuyue" @click="goDetail(i)">
              <div v-if="i.Status == '0'" class="card_yuyue">
                <div class="img_box">
                  <img :src="i.Cover" alt />
                  <span>预约中</span>
                </div>
                <div class="card_text">
                  <div class="top">
                    <p class="top_1">{{ i.Title }}</p>
                    <p class="top_2">
                      报名时间：{{ i.RegistrationStartTime.substring(0, 10) }}
                      至
                      {{ i.RegistrationEndTime.substring(0, 10) }}
                    </p>
                    <p class="top_2">
                      活动时间：{{ i.ActivityStartTime.substring(0, 10) }} 至
                      {{ i.ActivityEndTime.substring(0, 10) }}
                    </p>
                  </div>
                  <el-divider></el-divider>
                  <div class="botm">
                    <div class="botm_center">
                      <div class="botm_center_left">
                        <img src="../../../assets/activity/联合 13.png" alt />
                        <span class="span_2">累计播放</span>
                        <span class="span_1">{{ i.Spare10 }}次</span>
                       
                      </div>
                      <el-button>参会报名</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="i.Status == '1'" class="card_zhibo">
                <div class="img_box">
                  <img :src="i.Cover" alt />
                  <span>直播中</span>
                </div>
                <div class="card_text">
                  <div class="top">
                    <p class="top_1">{{ i.Title }}</p>
                    <p class="top_2">
                      报名时间：{{ i.RegistrationStartTime.substring(0, 10) }}
                      至
                      {{ i.RegistrationEndTime.substring(0, 10) }}
                    </p>
                    <p class="top_2">
                      活动时间：{{ i.ActivityStartTime.substring(0, 10) }} 至
                      {{ i.ActivityEndTime.substring(0, 10) }}
                    </p>
                  </div>
                  <el-divider></el-divider>
                  <div class="botm">
                    <div class="botm_center">
                      <div class="botm_center_left">
                        <img src="../../../assets/activity/联合 13.png" alt />
                        <span class="span_2">累计播放</span>
                        <span class="span_1">{{ i.Spare10 }}次</span>
                        
                      </div>
                      <el-button>观看直播</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="i.Status == '2'" class="card_huikan">
                <div class="img_box">
                  <img :src="i.Cover" alt />
                  <span>可回看</span>
                </div>
                <div class="card_text">
                  <div class="top">
                    <p class="top_1">{{ i.Title }}</p>
                    <p class="top_2">
                      报名时间：{{ i.RegistrationStartTime.substring(0, 10) }}
                      至
                      {{ i.RegistrationEndTime.substring(0, 10) }}
                    </p>
                    <p class="top_2">
                      活动时间：{{ i.ActivityStartTime.substring(0, 10) }} 至
                      {{ i.ActivityEndTime.substring(0, 10) }}
                    </p>
                  </div>
                  <el-divider></el-divider>
                  <div class="botm">
                    <div class="botm_center">
                      <div class="botm_center_left">
                        <img src="../../../assets/activity/联合 13.png" alt />
                        <span class="span_2">累计播放</span>
                        <span class="span_1">{{ i.Spare10 }}次</span>
                        
                      </div>
                      <el-button>观看回放</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="i.Status == '3'" class="card_huikan">
                <div class="img_box">
                  <img :src="i.Cover" alt />
                  <span>已结束</span>
                </div>
                <div class="card_text">
                  <div class="top">
                    <p class="top_1">{{ i.Title }}</p>
                    <p class="top_2">
                      报名时间：{{ i.RegistrationStartTime.substring(0, 10) }}
                      至
                      {{ i.RegistrationEndTime.substring(0, 10) }}
                    </p>
                    <p class="top_2">
                      活动时间：{{ i.ActivityStartTime.substring(0, 10) }} 至
                      {{ i.ActivityEndTime.substring(0, 10) }}
                    </p>
                  </div>
                  <el-divider></el-divider>
                  <div class="botm">
                    <div class="botm_center">
                      <div class="botm_center_left">
                        <img src="../../../assets/activity/联合 13.png" alt />
                        <span class="span_2">累计播放</span>
                        <span class="span_1">{{ i.Spare10 }}次</span>
                      </div>
                      <el-button>已结束</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 分页 -->
        
          <Pagination
           :page-size="limit"
            :page.sync="searchForm.page"
            :total= "total"
            @pagination=" getListData"
          />
       
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import Pagination from '../components/Pagination/index.vue'

import { postAction, getAction } from '@/api/api.js'
import { science } from '../../../api/url.js'
export default {
  name: '',
  data() {
    return {
      acitiviKind: [
        {
          Title: '全部',
          ID: '',
        },
      ],
      acitiviState: [
        {
          name: '全部',
          code: '',
        },
        {
          name: '预约中',
          code: '0',
        },
        {
          name: '直播中',
          code: '1',
        },
        {
          name: '可回看',
          code: '2',
        },
      ],
      searchForm: {
        action: 'Get_TechnologyActivityList',
        Title: '',
        page: 1,
        pageSize: 12,
        Type: '',
        Status: '',
      },
      total: 0,
      limit:12,
      records: [], // 所有数据
      DataList: [],
    }
   
  },
  props: {},
  components: {
    Pagination,
  },
  created() {
    this.getType()
    this.getListData()
  },
  
  mounted() {},
  methods: {
    getType() {
      getAction(science, { action: 'Cet_Type' }).then((res) => {
        this.acitiviKind = [...this.acitiviKind, ...res]
      })
    },
    changeUnitA(a) {
      this.searchForm.Type = a.ID
      this.getListData()
      // this.getCardData();
    },
    changeTechA(a) {
      this.searchForm.Status = a.code
      this.getListData()
      // this.getCardData();
    },
    getCardData(val) {
      this.searchForm.page = val.page
      this.getListData()
    },
    getListData() {
      getAction(science, this.searchForm).then((res) => {
     console.log("科技活动",res);
          this.total = res.count

        this.DataList = res.data
      })
    },
    goDetail(i) {
      //判断是否是PC设备，true是，false不是
      let userAgentInfo = navigator.userAgent
      let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod']
      let flag = true
      for (let j = 0; j < Agents.length; j++) {
        if (userAgentInfo.indexOf(Agents[j]) > 0) {
          flag = false
          break
        }
      }
      if (window.screen.width >= 768) {
        flag = true
      }
      if (flag) {
        this.$router.push({
          path: '/activityDetail',
          query: { id: i.ID },
        })
      } else {
        window.location.href=this.Urls+'Mobile/index.html#/AcitivityDetail?id=' +
           i.ID
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  background: url('../../../assets/Home/组 23358@2x.png');
  background-size: 100% 100%;
}
.center {
  width: 87.5rem;
  margin: 0 auto;
  padding: 1.875rem 0;
}
.head_choose {
  width: 84.25rem;
  padding: 2.0625rem 1.625rem;
  box-shadow: 0rem 0.1875rem 1rem rgba(0, 0, 0, 0.08);
  background-color: #fff;
  .choose_unit {
    display: flex;
    justify-content: flex-start;
    margin: 0.9375rem;
    align-items: baseline;
    // > span {
    //   align-content: center;
    //   font-size: 1rem;
    //   font-family: Microsoft YaHei;
    //   font-weight: bold;
    //   color: #4a4a4a;
    //   opacity: 1;
    // }
    .center_box {
      display: flex;
      flex-direction: row;
      width: 62.5rem;
      overflow: hidden;
      flex: 1;
      flex-wrap: wrap;
      .center_box_child {
        margin-left: 2.25rem;
        word-break: keep-all;
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 1.875rem;
        opacity: 1;
        cursor: pointer;
        padding: 0.3125rem 0.9375rem;
      }
      .isActiv {
        background: #2769dc;
        opacity: 1;
        color: #ffffff;
        border-radius: 0.3125rem;
      }
    }
    .pack_up {
      flex-wrap: nowrap;
    }
    .sel_box {
      margin-left: 2.25rem;
      .el-select {
        margin-left: 0.9375rem;
      }
    }
  }
}
.card_box_yuyue {
  margin-top: 1.875rem;
  display: flex;
  justify-content: space-between;
  .card_yuyue {
    display: inline-block;
    &:hover {
      box-sizing: border-box;
      box-shadow: 0rem 0.1875rem 1.25rem rgba(0, 0, 0, 0.1);
    }
    width: 27.6875rem;
    height: 29.6875rem;
    background: #ffffff;
    // box-shadow: 0rem 0.1875rem 1.25rem rgba(0, 0, 0, 0.1);
    opacity: 1;
    border-radius: 0rem;
    .img_box {
      width: 27.6875rem;
      height: 15rem;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        vertical-align: bottom;
      }
      span {
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        opacity: 1;
        background: #0561d2;
        opacity: 1;
        padding: 0.3125rem 0.625rem;
        border-radius: 0.125rem;
        position: absolute;
        top: 0.375rem;
        right: 0.3125rem;
      }
    }
    .card_text {
      //display: inline-block;
      padding: 1.4375rem 1.5rem;
      text-align: left;
      .top {
        .top_1 {
          font-size: 1.1875rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 1.6875rem;
          color: #0561d2;
          opacity: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          //white-space: nowrap;
        }
        .top_2 {
          font-size: 0.875rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 1.75rem;
          color: #8b8b8b;
          opacity: 1;
        }
      }
      .botm {
        .botm_center {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .botm_center_left {
            display: flex;
            align-items: center;
            img {
              width: 0.775rem;
              height: 0.8625rem;
              vertical-align: bottom;
              margin-right: 0.3125rem;
            }
            span {
              height: 1.0625rem;
              font-size: 0.8125rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              opacity: 1;
            }
            .span_1 {
              color: #ff8139;
              margin-left: 0.3125rem;
            }
            .span_2 {
              color: #aaaaaa;
              
            }
          }
        }
      }
    }
  }
  .card_zhibo {
    display: inline-block;
    &:hover {
      cursor: pointer;
      box-shadow: 0rem 0.1875rem 1.25rem rgba(0, 0, 0, 0.1);
      box-sizing: border-box;
      border: 1px solid #2769dc;
    }
    width: 27.6875rem;
    height: 29.6875rem;
    background: #ffffff;
    // box-shadow: 0rem 0.1875rem 1.25rem rgba(0, 0, 0, 0.1);
    opacity: 1;
    border-radius: 0rem;
    .img_box {
      width: 27.6875rem;
      height: 15rem;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        vertical-align: bottom;
      }
      span {
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        opacity: 1;
        background: #ff9e57;
        opacity: 1;
        padding: 0.3125rem 0.625rem;
        border-radius: 0.125rem;
        position: absolute;
        top: 0.375rem;
        right: 0.3125rem;
      }
    }
    .card_text {
      padding: 1.4375rem 1.5rem;
      text-align: left;
      .top {
        height: 8rem;
        .top_1 {
          font-size: 1.1875rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 1.6875rem;
          color: #0561d2;
          opacity: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          //white-space: nowrap;
        }
        .top_2 {
          font-size: 0.875rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 1.75rem;
          color: #8b8b8b;
          opacity: 1;
        }
      }
      .botm {
        .botm_center {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .botm_center_left {
            display: flex;
            align-items: center;
            img {
              width: 0.775rem;
              height: 0.8625rem;
              vertical-align: bottom;
              margin-right: 0.3125rem;
            }
            span {
              height: 1.0625rem;
              font-size: 0.8125rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              opacity: 1;
            }
            .span_1 {
              color: #ff8139;
              margin-left: 0.3125rem;
            }
            .span_2 {
              color: #aaaaaa;
              
            }
          }
        }
      }
    }
  }
  .card_huikan {
    &:hover {
      box-shadow: 0rem 0.1875rem 1.25rem rgba(0, 0, 0, 0.1);
      box-sizing: border-box;
      border: 1px solid #2769dc;
    }
    width: 27.6875rem;
    height: 31.6875rem;
    background: #ffffff;
    // box-shadow: 0rem 0.1875rem 1.25rem rgba(0, 0, 0, 0.1);
    opacity: 1;
    border-radius: 0rem;
    .img_box {
      width: 27.6875rem;
      height: 15rem;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        vertical-align: bottom;
      }
      span {
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        opacity: 1;
        background: #10c2b0;
        opacity: 1;
        padding: 0.3125rem 0.625rem;
        border-radius: 0.125rem;
        position: absolute;
        top: 0.375rem;
        right: 0.3125rem;
      }
    }
    .card_text {
      padding: 1.4375rem 1.5rem;
      text-align: left;
      .top {
        height: 8rem;
        .top_1 {
          font-size: 1.1875rem;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 1.6875rem;
          color: #0561d2;
          opacity: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          //white-space: nowrap;
        }
        .top_2 {
          font-size: 0.875rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 1.75rem;
          color: #8b8b8b;
          opacity: 1;
        }
      }
      .botm {
        .botm_center {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .botm_center_left {
            display: flex;
            align-items: center;
            height: 1.0625rem;
            img {
              width: 0.775rem;
              height: 0.8625rem;
              vertical-align: bottom;
              margin-right: 0.3125rem;
            }
            span {
              height: 1.0625rem;
              font-size: 0.8125rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              opacity: 1;
            }
            .span_1 {
              color: #ff8139;
              margin-left: 0.3125rem;
            }
            .span_2 {
              color: #aaaaaa;
             
            }
          }
        }
      }
    }
  }
}
.listContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  &:after {
    content: '';
    width: 27.6875rem;
  }
}
/deep/ .el-divider.el-divider--horizontal{
  margin: 20px 0px;
}
/deep/ .el-button {
  display: inline-block;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 0.0625rem solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  padding: 0.75rem 1.25rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
  span {
    color: #0561d2;
  }
}
</style>